import { VerticalDataProperty } from '@features/benchmarks';
import { TableHead as MuiTableHead, TableCell, TableRow } from '@mui/material';

export const orderedProperties = [
  'name',
  'lowerQuartile',
  'median',
  'upperQuartile',
] as const satisfies readonly VerticalDataProperty[];

const verticalDataLabels = {
  lowerQuartile: '25th Percentile',
  median: 'Median',
  upperQuartile: '75th Percentile',
} as const satisfies Record<Exclude<VerticalDataProperty, 'name'>, string>;

export type TableHeadProps = {
  nameLabel: string;
};

export const TableHead = (props: TableHeadProps) => {
  const labels = { ...verticalDataLabels, name: props.nameLabel };

  return (
    <MuiTableHead>
      <TableRow>
        {orderedProperties.map(property => (
          <TableCell key={property} sx={{ fontWeight: 'bold' }}>
            {labels[property]}
          </TableCell>
        ))}
      </TableRow>
    </MuiTableHead>
  );
};
